(function($) {
	'use strict';

	var cardselector    = $('[data-checkout-select-card]');
	cardselector.on('change', updateView);

	function updateView(event) {
	    var $this = $(event.target);
	    var optionsBlock = $('#paymentmethodsBlock');
	    var cardid = $this.val();
	    if (cardid !== '') {
	        optionsBlock.hide();
	    } else {
	        optionsBlock.show();
	    }
	}

	
})($jq);
